module.exports = __webpack_public_path__ + "img/1482134804985.84f86fe0.jpg";